(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    /*
==========================================================
PRODUCT PAGE DROPDOWN JAVASCRIPT

IMPORTANT:
This JS only targets [data-product-quantity-dropdown].

Therefore cart drawer native - / + buttons are completely
handled by Shopify/Horizon.
==========================================================
*/


if (!window.__apexProductQuantityDropdownInitialized) {

  window.__apexProductQuantityDropdownInitialized = true;


  /* --------------------------------------------------------
     CLOSE ALL PRODUCT DROPDOWNS
  -------------------------------------------------------- */

  function closeProductQuantityDropdowns(exceptSelector) {

    document
      .querySelectorAll('[data-product-quantity-dropdown]')
      .forEach(function (selector) {

        if (
          exceptSelector &&
          selector === exceptSelector
        ) {
          return;
        }


        var list =
          selector.querySelector(
            '.quantity-selector__options'
          );


        var button =
          selector.querySelector(
            '.quantity-selector__display'
          );


        if (list) {

          list.setAttribute(
            'hidden',
            ''
          );

        }


        if (button) {

          button.setAttribute(
            'aria-expanded',
            'false'
          );

        }


        selector.classList.remove(
          'is-open'
        );


        selector.classList.remove(
          'quantity-selector--dropup'
        );

      });

  }


  /* --------------------------------------------------------
     CHECK DROPDOWN DIRECTION
  -------------------------------------------------------- */

  function setProductDropdownDirection(selector) {

    if (!selector) {
      return;
    }


    selector.classList.remove(
      'quantity-selector--dropup'
    );


    var button =
      selector.querySelector(
        '.quantity-selector__display'
      );


    var list =
      selector.querySelector(
        '.quantity-selector__options'
      );


    if (!button || !list) {
      return;
    }


    var rect =
      button.getBoundingClientRect();


    var dropdownHeight =
      Math.min(
        list.scrollHeight || 220,
        220
      );


    var spaceBelow =
      window.innerHeight -
      rect.bottom;


    var spaceAbove =
      rect.top;


    if (
      spaceBelow < dropdownHeight + 16 &&
      spaceAbove > spaceBelow
    ) {

      selector.classList.add(
        'quantity-selector--dropup'
      );

    }

  }


  /* --------------------------------------------------------
     CLICK HANDLER
  -------------------------------------------------------- */

  document.addEventListener(
    'click',
    function (event) {

      if (!(event.target instanceof Element)) {
        return;
      }


      var displayButton =
        event.target.closest(
          '[data-product-quantity-dropdown] .quantity-selector__display'
        );


      var option =
        event.target.closest(
          '[data-product-quantity-dropdown] .quantity-selector__option'
        );


      /* ======================================================
         OPEN / CLOSE PRODUCT DROPDOWN
      ====================================================== */

      if (displayButton) {

        event.preventDefault();


        var selector =
          displayButton.closest(
            '[data-product-quantity-dropdown]'
          );


        if (!selector) {
          return;
        }


        var list =
          selector.querySelector(
            '.quantity-selector__options'
          );


        if (!list) {
          return;
        }


        var currentlyClosed =
          list.hasAttribute(
            'hidden'
          );


        closeProductQuantityDropdowns(
          selector
        );


        if (currentlyClosed) {

          list.removeAttribute(
            'hidden'
          );


          displayButton.setAttribute(
            'aria-expanded',
            'true'
          );


          selector.classList.add(
            'is-open'
          );


          requestAnimationFrame(
            function () {

              setProductDropdownDirection(
                selector
              );

            }
          );

        } else {

          list.setAttribute(
            'hidden',
            ''
          );


          displayButton.setAttribute(
            'aria-expanded',
            'false'
          );


          selector.classList.remove(
            'is-open'
          );


          selector.classList.remove(
            'quantity-selector--dropup'
          );

        }


        return;
      }


      /* ======================================================
         SELECT PRODUCT QUANTITY
      ====================================================== */

      if (option) {

        event.preventDefault();


        var selector =
          option.closest(
            '[data-product-quantity-dropdown]'
          );


        if (!selector) {
          return;
        }


        var realInput =
          selector.querySelector(
            '.quantity-selector__real-input'
          );


        var displayValue =
          selector.querySelector(
            '.quantity-selector__display-value'
          );


        var list =
          selector.querySelector(
            '.quantity-selector__options'
          );


        var display =
          selector.querySelector(
            '.quantity-selector__display'
          );


        if (
          !realInput ||
          !displayValue ||
          !list
        ) {
          return;
        }


        var value =
          option.getAttribute(
            'data-value'
          );


        /* Update actual Shopify quantity */

        realInput.value = value;


        /* Update visible value */

        displayValue.textContent =
          value;


        /* Remove old selected states */

        list
          .querySelectorAll(
            '.quantity-selector__option'
          )
          .forEach(function (item) {

            item.classList.remove(
              'is-selected'
            );


            item.setAttribute(
              'aria-selected',
              'false'
            );

          });


        /* Set new selected state */

        option.classList.add(
          'is-selected'
        );


        option.setAttribute(
          'aria-selected',
          'true'
        );


        /* Close dropdown */

        list.setAttribute(
          'hidden',
          ''
        );


        if (display) {

          display.setAttribute(
            'aria-expanded',
            'false'
          );

        }


        selector.classList.remove(
          'is-open'
        );


        selector.classList.remove(
          'quantity-selector--dropup'
        );


        /* Notify listeners */

        realInput.dispatchEvent(
          new Event(
            'input',
            {
              bubbles: true
            }
          )
        );


        realInput.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );


        /*
        Trigger Horizon /setQuantity.

        Focus + blur ensures Shopify's existing quantity
        component receives the quantity change normally.
        */

        try {

          realInput.focus({
            preventScroll: true
          });

        } catch (error) {

          realInput.focus();

        }


        realInput.blur();


        return;
      }


      /* ======================================================
         CLICK OUTSIDE
      ====================================================== */

      closeProductQuantityDropdowns();

    },
    true
  );


  /* --------------------------------------------------------
     ESC KEY
  -------------------------------------------------------- */

  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {

        closeProductQuantityDropdowns();

      }

    },
    true
  );


  /* --------------------------------------------------------
     CLOSE WHEN WINDOW CHANGES
  -------------------------------------------------------- */

  window.addEventListener(
    'resize',
    function () {

      closeProductQuantityDropdowns();

    },
    {
      passive: true
    }
  );

}
  } catch(e) { console.error(e); }
})();

})();
